module.exports = __webpack_public_path__ + "static/media/20682.e474c7e7.jpg";